import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './endpoint.config.service';


@Injectable({
  providedIn: 'root'
})
export class OperationsService extends ConnectionService {

  currentLocationId: any;

  constructor(http: HttpClient, private configs: ConfigService) {
    super(http);
    if (this.currentLocationId == undefined && sessionStorage.getItem("company") != undefined)
      this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
  }

  getIncomingShipments(requestBody, sucFun, errFun) {
    var endPoint = this.configs.getAppApiUrl("GET_INCOMING_SHIPMENTS").replace("{{currentLocationId}}", this.currentLocationId);
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("get", endPoint, requestBody, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }

  reconcileShipments(requestBody, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("RECONCILE_SHIPMENTS").replace("{{currentLocationId}}", this.currentLocationId);
    this.CallApi('post', endPoint, requestBody, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    })
  }

  validateCourierId(courierId, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("VALIDATE_COURIER").replace("{{currentLocationId}}", this.currentLocationId).replace("{{courierId}}", courierId);
    this.CallApi('post', endPoint, {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    })
  }

  closeTrip(courierId, shipments, penddingShipments, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("CLOSE_TRIP").replace("{{currentLocationId}}", this.currentLocationId).replace("{{tripId}}", courierId);
    this.CallApi('post', endPoint, { shipments: shipments, penddingShipments: penddingShipments } , null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    })
  }

  scanShipment(ShipmentNumber,asl, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("SCAN_SHIPMENT").replace("{{currentLocationId}}", this.currentLocationId).replace("{{shipmentNumber}}", ShipmentNumber).replace("{{asl}}", asl);
    this.CallApi('post', endPoint, {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    })
  }

  searchFleetersJobs(from, to, courierId, take, skip,sucFun,errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("SEARCH_FLEETER_JOBS").replace("{{currentLocationId}}", this.currentLocationId);
    this.CallApi("get", endPoint, { from: from, to: to, take: take,skip:skip, courierId: courierId }, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err)
    })
  }
  
  getSpotShipmentsDetailsByJobReference(jobReference, courierId, sucFun,errFun) {
   
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("GET_SPOT_SHIPMENTS_DETAILS").replace("{{currentLocationId}}", this.currentLocationId).replace("{{fleeterCourierId}}", courierId).replace("{{fleeterJobRefrence}}", jobReference);
    this.CallApi("get", endPoint, {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err)
    })
  }

}
